'use strict';

const jQuery = require('jquery');

const globalLoaderTpl = require('./templates/loader.hbs');
const container = require('./../../core/container');
const overlayMenu = require('./../overlay/menu');

const elementLoaderTpl = require('./templates/loader_element.hbs');

module.exports.start = function(element, position) {
    let $mask = jQuery('<div class="cloud-mask-loader"></div>');
    let $content = jQuery((element instanceof jQuery) ? elementLoaderTpl() : globalLoaderTpl());
    let $wrapper = (element instanceof jQuery) ? element : container.get('$siteWrapper');

    position = position || 'center';

    $content.addClass(position);

    if ($wrapper.css('position') === 'static') {
        $wrapper.addClass('cloud-relative');
    }

    if (!(element instanceof jQuery)) {
        $content.addClass('global');
    } else {
        if (element.hasClass('cloud-panel')) {
            overlayMenu.show();
        }
    }

    $mask.append($content);

    $wrapper.append($mask);
};

module.exports.stop = function(element) {
    if (element instanceof jQuery) {
        element.find('div.cloud-mask-loader').remove();
        element.removeClass('cloud-relative');
        overlayMenu.hide();
    } else {
        container.get('$siteWrapper').find('.cloud-mask-loader').remove();
    }
};
